import { API } from '../Client';
import { WatchlistAsset } from './types';

namespace WatchlistService {
  export async function getWatchlistAssets(includeMetadata = false, includeLatestQuote = false): Promise<WatchlistAsset[]> {
    const res = await API.get('price-alerts/watchlist', {
      params: {
        includeMetadata,
        includeLatestQuote,
      }
    });
    return res?.data || [];
  }

  export async function toggleFollowWatchlistAsset(body: { symbol: string, setFollow: boolean }): Promise<void> {
    await API.post(`price-alerts/watchlist${body.setFollow ? '' : '/delete-entry'}`, {
      stockId: body.symbol,
    });
  }
}

export default WatchlistService;
